export default "__VITE_ASSET__BDQS5MbA__"